import React, { Component } from "react";
import { connect } from "react-redux";
import QuestionNumber from "./../QuestionNumber";

import axios from "axios";
import Webcam from "react-webcam";
import config from "../../config/config-secret.json";
import { nextQuestion } from "./../../actions/assessment";

let count = 0;

export class ReadingComprehension extends Component {
  constructor(props) {
    super(props);

    this.webcamRef = React.createRef();
  }

  componentDidMount() {
    count = 0;
    // SaveUserStateToServerHelper(this.props.assessment);
  }

  onUserMediaError = () => {
    alert("Can't access webcam, please contact administrator.");
  };

  onUserMedia = () => {};

  addCaptureImage = (imageb64, taken_at) => {
    axios
      .post(config.API_URL + `/administer_test/save_security_image/`, {
        imageb64,
        taken_at,
        tester_id: this.props.assessment.tester_id,
      })
      .catch((error) => {
        console.log(error);
      });
  };

  nextQuestion = async (id) => {
    if (count < 1) {
      count += 1;
      window.localStorage.setItem(
        this.props.assessment.key,
        JSON.stringify(this.props.assessment)
      );

      const { tester_id, ...last_session_info } = this.props.assessment;
      axios
        .post(config.API_URL + "/administer_test/update_tester_session_info/", {
          tester_id: tester_id,
          last_session_info: JSON.stringify(last_session_info),
        })
        .then((res) => {
          document.querySelector("#initloader").style.display = "none";
          this.props.nextQuestion(this.props.question_id, [id]);
        })
        .catch((error) => {
          document.querySelector("#initloader").style.display = "none";
          console.error(error);

          // Get readable message from server if available
          const serverMessage =
            error.response?.data?.message ||
            error.response?.data ||
            error.message ||
            "Unknown error";

          alert(
            `There appears to be a problem sending data to our server.
Please check your internet connection and try refreshing your browser.

Error details: ${serverMessage}

If the issue persists, please contact your administrator.`
          );
        });
    }
  };

  render() {
    let letter = "";

    return (
      <div className="question">
        {this.props.assessment.has_security_features && (
          <Webcam
            className="col-12 mb-4"
            style={{
              position: "absolute",
              right: "100%",
              display: "block",
            }}
            screenshotFormat="image/jpeg"
            muted={false}
            ref={this.webcamRef}
            onUserMediaError={this.onUserMediaError}
            onUserMedia={this.onUserMedia}
          />
        )}

        <QuestionNumber />

        <div className="card q-reading mb-5">
          <div className="card-body">
            <div dangerouslySetInnerHTML={{ __html: this.props.context }}></div>
          </div>
        </div>

        <h4>
          <span>{this.props.questiontext}</span>
        </h4>

        <div className="choices-btn w-100" data-toggle="buttons">
          {!!this.props.choices &&
            this.props.choices.map((value, index) => {
              if (letter === "") {
                letter = "A";
              } else {
                letter = String.fromCharCode(letter.charCodeAt(0) + 1);
              }

              return (
                <label
                  key={value.id}
                  className="btn btn-outline-light"
                  onClick={() => {
                    this.nextQuestion(value.id);

                    if (this.props.assessment.has_security_features) {
                      this.addCaptureImage(
                        this.webcamRef.current.getScreenshot(),
                        new Date()
                      );
                    }
                  }}
                >
                  <input
                    key={value.id}
                    type="radio"
                    name="options"
                    id={"choice" + value.id}
                  />
                  <span className="letter-choice">{letter}</span>
                  {value.choice.text}
                </label>
              );
            })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  nextQuestion: (question_id, choice_ids) =>
    dispatch(nextQuestion(question_id, choice_ids)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReadingComprehension);
